// extracted by mini-css-extract-plugin
export default {"primaryButton":"App_primaryButton__2zMyJ","bPostButton":"App_bPostButton__4qa-D","saveAndContinue":"App_saveAndContinue__cX5IK","app":"App_app__GuJBs"};